import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {

    constructor(){}
  public isLoading: boolean = true;

  show() {
     return  true;
      
  }

  hide() {
   return false;
  }
}
